/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import Box from '@material-ui/core/Box';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router';
import Modal from '@material-ui/core/Modal';
import { object, string } from 'prop-types';
import Button from '@material-ui/core/Button';
import React, { useState, useEffect } from 'react';
import Accordion from '@material-ui/core/ExpansionPanel';
import withStyles from '@material-ui/core/styles/withStyles';
import { useSelector, connect } from 'react-redux';
import AccordionSummary from '@material-ui/core/ExpansionPanelSummary';
import AccordionDetails from '@material-ui/core/ExpansionPanelDetails';
import { MMDDYYYY } from '../../utils/dateString';
import AccountLeftMenu from '../../common/Desktop/AccountLeftMenu';
import { getBrand } from '../../state/ducks/Common/Common-Selectors';
import { getSSRDeviceType } from '../../../../../state/ducks/App/App-Selectors';
import fetchOrderDetailsAPI from '../../../../../apis/order-apis/fetchOrderDetails';
import { getFeatureFlags } from '../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getAccessToken } from '../../../../../state/ducks/Member/ducks/Common/Common-Selectors';
import { getAccessTokenSafely } from '../../../../../state/ducks/Member/ducks/Auth/Plugin/Auth/Auth';
import DesktopOrderTrackingPlants from '../DesktopOrderDetails/DesktopItemDetail/DesktopOrderTrackingPlants';
import GraphqlPortalLoader from '../../../../components/GraphqlComponents/GraphqlCommonComponents/GraphqlPortalLoader';

const styles = (theme) => ({
    CustomerWrapperPLA: {
        '&.PLA': {
            padding: '0 15px',
            maxWidth: '1270px',
            margin: '55px auto',
            flexDirection: 'column',
        },
    },
    CustomerOrders: {
        '& .no-orders-found': {
            display: 'block',
            textAlign: 'center',
            borderTop: '1px dashed #000',
            paddingTop: '3rem !important',
        },

        '& .accordion-container': {
            boxShadow: 'unset',
            borderTop: '1px dashed #000',

            '&:last-child': {
                borderBottom: '1px dashed #000',
            },

            '& .accordion-summary': {
                '& span': {
                    fontWeight: '700',
                    fontSize: '16px !important',
                    '&:before': {
                        content: '"+"',
                        paddingRight: '10px',
                    },
                },
                '&.Mui-expanded': {
                    '& span': {
                        '&:before': {
                            content: '"-"',
                            paddingRight: '10px',
                        },
                    },
                },
            },

            '& .accordion-details': {
                display: 'block',

                '& > span': {
                    '&:first-child': {
                        display: 'block',
                        fontWeight: '700',
                        fontSize: '0.6875rem',
                        textTransform: 'uppercase',
                    },

                    '& ~ button': {
                        top: '-12px',
                        position: 'relative',
                        marginBottom: '10px',
                        [theme.breakpoints.down('sm')]: {
                            float: 'right',
                        },
                    },
                },

                '& .thead': {
                    fontWeight: '700',
                    textTransform: 'uppercase',
                    marginTop: '1rem !important',
                    marginBottom: '.5rem !important',

                    '& > div': {
                        fontSize: '0.6875rem',
                    },
                },

                '& .tbody': {
                    rowGap: '10px',
                    padding: '10px 0',
                    alignItems: 'center',

                    '& > div': {
                        padding: '10px',
                        alignItems: 'center',
                        backgroundColor: '#F2F2F2',
                    },

                    '& .section': {
                        '& .order-status': {
                            textTransform: 'lowercase',
                        },

                        '&.tracking-number': {
                            '& > :first-child': {
                                display: 'none',
                            },

                            '& > :nth-child(2)': {
                                width: '100%',
                                maxWidth: '100%',
                                [theme.breakpoints.down('sm')]: {
                                    marginBottom: '1rem',
                                },
                            },
                        },
                    },

                    '& img': {
                        width: '50px',
                        marginRight: '0.5rem !important',

                        '& ~ .section': {
                            verticalAlign: 'top',
                            display: 'inline-block',

                            '& span': {
                                display: 'block',
                                fontSize: '11px !important',
                            },
                        },
                    },
                },
                '& .sm-hide': {
                    [theme.breakpoints.down('sm')]: {
                        display: 'none',
                    },
                },
                '& .sm-mt-1': {
                    [theme.breakpoints.down('sm')]: {
                        marginTop: '1rem',
                    },
                },
                '& .sm-screen': {
                    fontSize: '16px',
                    borderBottom: '0px',
                    marginBottom: '3px',
                    textTransform: 'uppercase !important',
                    [theme.breakpoints.up('md')]: {
                        display: 'none',
                    },
                },
            },
        },

        '& button': {
            textAlign: 'center',
            padding: '4px 0px !important',
            borderColor: `${theme.palette.primaryButton} !important`,
            backgroundColor: `${theme.palette.primaryButton} !important`,
            [theme.breakpoints.down('md')]: {
                padding: '4px 10px !important',
            },
            '& span': {
                color: 'black',
                fontSize: '11px !important',
            },
        },

        '& .modal-container': {
            height: '100vh',
            display: 'grid',
            alignItems: 'end',
            background: 'white',
            justifyContent: 'center',
        },
    },
});

const modalstyle = {
    pt: 3,
    px: 4,
    pb: 3,
    top: '50%',
    left: '50%',
    width: 500,
    boxShadow: 24,
    position: 'absolute',
    bgcolor: 'background.paper',
    transform: 'translate(-50%, -50%)',

    '& .bold': {
        fontWeight: 700,
    },

    '& .header': {
        display: 'grid',
        gridTemplateColumns: '80% auto',
        justifyContent: 'space-between',
        '& > div > span:last-child': {
            fontWeight: 700,
            marginLeft: '10px',
        },
        '& > span': {
            fontSize: '24px',
            fontWeight: 700,
            cursor: 'pointer',
        },
    },

    '& .product-detail': {
        '& img': {
            width: '50px',
            marginRight: '0.5rem !important',

            '& ~ .section': {
                verticalAlign: 'top',
                display: 'inline-block',

                '& span': {
                    display: 'block',
                    fontSize: '11px !important',
                },
            },
        },

        '& ~ .MuiGrid-root.sm-hide': {
            display: 'none',

            '& ~ .MuiGrid-root': {
                width: '100%',
                display: 'block',
                maxWidth: '100%',
                marginTop: '10px',

                '&.sm-screen > .sm-screen': {
                    display: 'none',
                },
            },
        },
    },
};

const OrderListing = ({
    brand,
    userProfile,
    classes,
    jwt,
    featureFlags,
}) => {
    const history = useHistory();
    const [orders, setOrders] = useState([]);
    const [quantity, setQuantity] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [openModal, setOpenModal] = useState(false);
    const [orderDetails, setOrderDetail] = useState({});

    if (useSelector(getSSRDeviceType) === 'mobile') {
        modalstyle.width = 350;
    }

    const getformattedOrderDetails = (orderData) => {
        const tempOrderDetails = {};
        orderData.orders.forEach((orderValue) => {
            const order = { ...orderValue };

            if (tempOrderDetails[order.orderNumber]) {
                tempOrderDetails[order.orderNumber].items.push(order.items[0]);
            } else {
                tempOrderDetails[order.orderNumber] = order;
            }
        });

        const formattedOrderDetails = JSON.parse(JSON.stringify(tempOrderDetails));

        // merge if we are getting same sku as multiple item.
        Object.keys(tempOrderDetails).forEach((orderId) => {
            formattedOrderDetails[orderId].items = [formattedOrderDetails[orderId].items[0]];
            tempOrderDetails[orderId].items.forEach((item, index) => {
                if (index !== 0 && tempOrderDetails[orderId].items[0].productSku === item.productSku) {
                    formattedOrderDetails[orderId].items[0].quantity = +formattedOrderDetails[orderId].items[0].quantity + +item.quantity;
                } else if (tempOrderDetails[orderId].items[0].productSku !== item.productSku) {
                    formattedOrderDetails[orderId].items.push(item);
                }
            });
        });

        return Object.values(formattedOrderDetails)[0];
    };

    useEffect(() => {
        (async () => {
            let orderResponse;

            const token = await getAccessTokenSafely();
            orderResponse = await fetchOrderDetailsAPI(token, { email: userProfile.email, user: 30016 }, {}, featureFlags['which-ross-api-version-enabled']);
            orderResponse = featureFlags['which-ross-api-version-enabled'] === 'v2' ? orderResponse?.data?.result : orderResponse?.data?.orders;

            let formattedOrders = {};
            if (orderResponse) {
                orderResponse.forEach((orderData) => {
                    const order = orderData;
                    if (order?.orderNumber?.indexOf('W') >= 0) {
                        return;
                    }

                    order.orders = [getformattedOrderDetails(order)];
                    if (formattedOrders[order.orderNumber]) {
                        const orderToPush = order.items ? order.items : order.orders;

                        if (formattedOrders[order.orderNumber].items) {
                            formattedOrders[order.orderNumber].items = [
                                ...formattedOrders[order.orderNumber].items,
                                ...orderToPush,
                            ];
                        } else {
                            formattedOrders[order.orderNumber].items = orderToPush;
                        }
                    } else {
                        formattedOrders[order.orderNumber] = order;
                    }
                });

                formattedOrders = Object.values(formattedOrders).reverse();
            }

            setIsLoading(false);
            setOrders(formattedOrders);
        })();
    }, []);

    const handleToggleModal = (order) => {
        setOpenModal(!openModal);
        setOrderDetail(order.target ? {} : order);
    };

    const handleChange = async (selectedOrder) => {
        if (!quantity[selectedOrder.orderNumber]) {
            const orderResponse = await fetchOrderDetailsAPI(jwt, { user: 30076, orderNumber: selectedOrder.orderNumber }, {}, featureFlags['which-ross-api-version-enabled']);

            let quantityCollection = {};
            orderResponse.data.orders.forEach((order) => {
                const { items = [] } = order;
                const item = items[0];
                if (quantityCollection[item.productSku]) {
                    quantityCollection[item.productSku] += +item.quantity;
                } else {
                    quantityCollection = { ...quantityCollection, [item.productSku]: +item.quantity };
                }
            });

            setQuantity({ ...quantity, [selectedOrder.orderNumber]: quantityCollection });
            setIsLoading(true);
        }
    };

    const redirectToOrderDetail = (order) => history.push(`/account/order/${order.orderNumber}`);

    const renderNoOrders = () => (isLoading ? <GraphqlPortalLoader /> : (
        <div className="no-orders-found">
            No orders found
        </div>
    ));

    const sourceIdforModal = orderDetails?.orderNumber?.indexOf('W') >= 0 ? '' : 'W0100';

    return (
        <Grid className={`${classes.CustomerWrapperPLA} ${brand.code} ${classes.CustomerOrders}`}>
            <AccountLeftMenu
                userProfile={userProfile}
                brand={brand}
            />
            {
                Object.keys(orderDetails).length
                    ? (
                        <Modal
                            aria-labelledby="modal-title"
                            aria-describedby="modal-description"
                            open={openModal}
                            onClose={handleToggleModal}
                        >
                            <Box sx={{ ...modalstyle }}>
                                <div className="header">
                                    <div>
                                        <span>Order Number:</span>
                                        <span>{sourceIdforModal}{orderDetails.orderNumber}</span>
                                    </div>
                                    <span onClick={handleToggleModal} role="presentation">x</span>
                                </div>
                                {orderDetails.items.map((data) => (
                                    <Grid className="product-detail" key={data.productName}>
                                        <img src={data.prdImgCtg ? data.prdImgCtg.replace('http://', 'https://') : data.prdImgCtg} alt="product-image" />
                                        <div className="section">
                                            <span className="bold">QTY: {quantity?.[orderDetails.orderNumber]?.[data.productSku]}</span>
                                            <span>{data.productName}</span>
                                        </div>
                                    </Grid>
                                ))}

                                <DesktopOrderTrackingPlants
                                    data={{
                                        status: orderDetails.status,
                                        trackingNumber: orderDetails.trackingNumber,
                                        carrier: orderDetails.carrier,
                                        isPassport: null,
                                    }}
                                />
                            </Box>
                        </Modal>
                    ) : ''
            }
            {
                orders.length
                    ? (
                        <>
                            {orders.map((orderData) => {
                                let order; let Enable = false;
                                if (featureFlags['which-ross-api-version-enabled'] === 'v2') {
                                    order = orderData.orders[0];
                                    Enable = true;
                                } else {
                                    order = orderData;
                                }
                                const sourceId = order?.orderNumber?.indexOf('W') >= 0 ? '' : order?.items?.[0]?.sourceId || 'W0100';

                                return (
                                    <Accordion className="accordion-container" onChange={() => handleChange(order)} key={order.orderNumber}>
                                        <AccordionSummary className="accordion-summary">
                                            <span>Order Number: {sourceId}{order.orderNumber}</span>
                                        </AccordionSummary>
                                        <AccordionDetails className="accordion-details">
                                            <span>Order Date</span>
                                            <span>{MMDDYYYY(order.orderPlacedDate)}</span>

                                            <Button
                                                type="button"
                                                color="primary"
                                                variant="contained"
                                                onClick={() => redirectToOrderDetail(order)}
                                            >
                                                View Order
                                            </Button>

                                            <Grid>
                                                <Grid container className="thead sm-hide">
                                                    <Grid xs={2} sm={2} md={4} lg={4}>Items Ordered:</Grid>
                                                    <Grid xs={2} sm={2} md={2} lg={2}>Delivery Date:</Grid>
                                                    <Grid xs={2} sm={2} md={2} lg={2}>Order Status:</Grid>
                                                    <Grid xs={2} sm={2} md={2} lg={2}>Tracking Number:</Grid>
                                                    <Grid xs={2} sm={2} md={2} lg={2} />
                                                </Grid>
                                                <Grid container className="tbody">
                                                    {
                                                        Enable ? (
                                                            <>{
                                                                orderData.orders.map((obj) => {
                                                                    const innerOrder = obj;
                                                                    return (innerOrder.items.map((data) => (
                                                                        <Grid container key={data.productSku}>
                                                                            <Grid xs={6} sm={6} md={4} lg={4}>
                                                                                <img src={data.prdImgCtg ? data.prdImgCtg.replace('http://', 'https://') : data.prdImgCtg} alt="product-image" />
                                                                                <div className="section">
                                                                                    <span className="bold">QTY: {quantity?.[order.orderNumber]?.[data.productSku]}</span>
                                                                                    <span>{data.productName}</span>
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={6} sm={6} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section">
                                                                                    <span>{data.estimatedDeliveryDate && MMDDYYYY(data.estimatedDeliveryDate)}</span>
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={12} sm={12} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section">
                                                                                    <span>Your order has been <span className="order-status">{innerOrder.status}</span></span>
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={12} sm={12} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section tracking-number">
                                                                                    <DesktopOrderTrackingPlants
                                                                                        data={{
                                                                                            status: innerOrder.status,
                                                                                            trackingNumber: innerOrder.trackingNumber,
                                                                                            carrier: innerOrder.carrier,
                                                                                            isPassport: null,
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={6} sm={6} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section">
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="primary"
                                                                                        type="submit"
                                                                                        onClick={() => handleToggleModal(innerOrder)}
                                                                                    >
                                                                                        TRACK ORDER
                                                                                    </Button>
                                                                                </div>
                                                                            </Grid>
                                                                        </Grid>
                                                                    ))
                                                                    );
                                                                })

                                                            }
                                                            </>
                                                        ) : (
                                                            <>
                                                                {
                                                                    order.items.map((data) => (
                                                                        <Grid container key={data.productSku}>
                                                                            <Grid xs={6} sm={6} md={4} lg={4}>
                                                                                <img src={data.prdImgCtg} alt="product-image" />
                                                                                <div className="section">
                                                                                    <span className="bold">QTY: {data.quantity}</span>
                                                                                    <span>{data.productName}</span>
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={6} sm={6} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section">
                                                                                    <span>{data.estimatedDeliveryDate && MMDDYYYY(data.estimatedDeliveryDate)}</span>
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={12} sm={12} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section">
                                                                                    <span>Your order has been <span className="order-status">{order.status}</span></span>
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={12} sm={12} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section tracking-number">
                                                                                    <DesktopOrderTrackingPlants
                                                                                        data={{
                                                                                            status: order.status,
                                                                                            trackingNumber: order.trackingNumber,
                                                                                            carrier: order.carrier,
                                                                                            isPassport: null,
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </Grid>

                                                                            <Grid xs={6} sm={6} md={2} lg={2} className="sm-mt-1">
                                                                                <div className="section">
                                                                                    <Button
                                                                                        variant="contained"
                                                                                        color="primary"
                                                                                        type="submit"
                                                                                        onClick={() => handleToggleModal(order)}
                                                                                    >
                                                                                        TRACK ORDER
                                                                                    </Button>
                                                                                </div>
                                                                            </Grid>
                                                                        </Grid>
                                                                    ))
                                                                }
                                                            </>
                                                        )
                                                    }
                                                </Grid>
                                            </Grid>
                                        </AccordionDetails>
                                    </Accordion>
                                );
                            })}
                        </>
                    )
                    : renderNoOrders()
            }
        </Grid>
    );
};

OrderListing.propTypes = {
    jwt: string.isRequired,
    brand: object.isRequired,
    classes: object.isRequired,
    userProfile: object.isRequired,
    featureFlags: object.isRequired,
};

const mapDispatchToProps = (state) => ({
    brand: getBrand(state),
    jwt: getAccessToken(state),
    featureFlags: getFeatureFlags(state),
});

export default connect(mapDispatchToProps)(withStyles(styles)(OrderListing));
